import { render, staticRenderFns } from "./historical-settlement-inquiry.vue?vue&type=template&id=e8993820&scoped=true&"
import script from "./historical-settlement-inquiry.vue?vue&type=script&lang=js&"
export * from "./historical-settlement-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./historical-settlement-inquiry.vue?vue&type=style&index=0&id=e8993820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8993820",
  null
  
)

export default component.exports